import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-i-skeleton',
  templateUrl: './i-skeleton.component.html',
  styleUrls: ['./i-skeleton.component.scss'],
})
export class ISkeletonComponent  implements OnInit {

  constructor() { }

  ngOnInit() {}

}
